/** @jsx jsx */
import { jsx } from 'theme-ui'
import StructuredData from '~/components/StructuredData'

const StructuredFaqPageData = ({ questions }) => {
  // @see https://developers.google.com/search/docs/appearance/structured-data/faqpage
  return (
    <StructuredData
      type="FAQPage"
      data={{
        mainEntity: questions.map((question) => ({
          '@type': 'Question',
          name: question?.question?.question?.trim(),
          acceptedAnswer: {
            '@type': 'Answer',
            text: question.answer.childMarkdownRemark.html,
          },
        })),
      }}
    />
  )
}

export default StructuredFaqPageData
